import React from 'react';
import { Sheet, SheetContent, SheetDescription, SheetFooter, SheetHeader, SheetTitle } from 'src/shared/components/ui/sheet';
import { Button } from 'src/shared/components/ui/button';
import BulkRunSummary from './BulkRunSummary';
import type { BulkRun } from '../bulkRun';

type BulkOnboardSheetProps = {
    open: boolean;
    count: number;
    run: BulkRun | null;
    onConfirm: () => void;
    onStop: () => void;
    onClose: () => void;
};

const BulkOnboardSheet = ({ open, count, run, onConfirm, onStop, onClose }: BulkOnboardSheetProps) => {
    const isRunning = run?.status === 'running';

    const handleOpenChange = (nextOpen: boolean) => {
        const isClosingAfterRun = nextOpen === false && isRunning === false;
        if (isClosingAfterRun) {
            onClose();
        }
    };

    return (
        <Sheet open={open} onOpenChange={handleOpenChange}>
            <SheetContent hideCloseButton={isRunning} className='flex flex-col gap-6'>
                <SheetHeader>
                    <SheetTitle>Onboard all missing</SheetTitle>
                    <SheetDescription>Each Sunset only customer gets an organisation in Sunrise.</SheetDescription>
                </SheetHeader>
                {run ? (
                    <BulkRunSummary run={run} onStop={onStop} />
                ) : (
                    <>
                        <p className='text-sm font-medium'>Onboard {count} customers into Sunrise?</p>
                        <SheetFooter>
                            <Button type='button' variant='outline' onClick={onClose}>
                                Cancel
                            </Button>
                            <Button type='button' className='flex-grow' onClick={onConfirm}>
                                Onboard all
                            </Button>
                        </SheetFooter>
                    </>
                )}
            </SheetContent>
        </Sheet>
    );
};

export default BulkOnboardSheet;
